module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-7.fdbc457c.png";